import React from 'react';
import PropTypes from 'prop-types';
import * as commonLogic from '../../../logic/CommonLogic';

const NumberStyle = { color: 'var(--color-scheme-col-minus)' };

/**
 * MainGridMiddleRightRowDayOnTypePachi
 */
class MainGridMiddleRightRowDayOnTypePachi extends React.Component {

  render() {
    // 納品開始日
    let nohinkaishibi = dispDataFormatSlash(this.props.dataDayOnItem.nohinkaishibi);

    // アウト
    let stringItem1 = '-';
    if (this.props.dataDayOnItem.koumoku1 !== '') {
      stringItem1 = commonLogic.numberFormat(this.props.dataDayOnItem.koumoku1, 0);

    }

    // 台売上
    let stringItem2 = '-';
    if (this.props.dataDayOnItem.koumoku2 !== '') {
      stringItem2 = commonLogic.numberFormat(this.props.dataDayOnItem.koumoku2, 0);
    }

    // 台粗利
    let stringItem3 = '-';
    if (this.props.dataDayOnItem.koumoku3 !== '') {
      stringItem3 = commonLogic.numberFormat(this.props.dataDayOnItem.koumoku3, 0);
    }

    // 玉単価
    let stringItem4 = '-';
    if (this.props.dataDayOnItem.koumoku4 !== '') {
      stringItem4 = commonLogic.numberFormat(this.props.dataDayOnItem.koumoku4, 2);
    }

    // 玉粗利
    let stringItem5 = '-';
    if (this.props.dataDayOnItem.koumoku5 !== '') {
      stringItem5 = commonLogic.numberFormat(this.props.dataDayOnItem.koumoku5, 2);
    }

    // 中古価格
    let stringItem6 = '-';
    let stringItem6Style = null;
    if (this.props.dataDayOnItem.koumoku6 !== '' && this.props.dataDayOnItem.koumoku6 !== 0) {
      stringItem6 = commonLogic.numberFormat(this.props.dataDayOnItem.koumoku6, 0);
      if (parseFloat(stringItem6) < 0) {
        stringItem6Style = 'minus_value';
      }
    }
    // 中古価格の機種コード(p-sensor機種コード)
    let kisyuCd = '';
    const psensorInfo = this.props.dataDayOnItem.p_sensor;
    if (psensorInfo !== undefined) {
      kisyuCd = psensorInfo.kisyu_cd;
    }

    // 中古価格増減
    let stringItem7 = '-';
    if (this.props.dataDayOnItem.koumoku7 !== '') {
      if (this.props.dataDayOnItem.koumoku7 != undefined && this.props.dataDayOnItem.koumoku7 != 0) {
        stringItem7 = commonLogic.numberFormat(this.props.dataDayOnItem.koumoku7, 0);
        if (0 < parseInt(stringItem7.replace(/,/g, ''), 10)) {
          stringItem7 = '+' + stringItem7;
        }
      } else {
        stringItem7 = String(0);
      }
    }
    function formatItemYen(s) {
      if (s === '-') return <p>{s}</p>;
      if (s.startsWith("+")) return <p>+&yen;{s.slice(1)}</p>;
      if (s.startsWith("-")) return <p style={NumberStyle}>-&yen;{s.slice(1)}</p>;
      return <p className="noto-sans-text">&plusmn;&yen;{s}</p>;
    }

    // 平気設置台数
    let stringItem8 = '-';
    if (this.props.dataDayOnItem.koumoku8 !== '') {
      stringItem8 = commonLogic.numberFormat(this.props.dataDayOnItem.koumoku8, 2);
    }

    // スタート
    let stringItem9 = '-';
    if (this.props.dataDayOnItem.koumoku9 !== '') {
      stringItem9 = commonLogic.numberFormat(this.props.dataDayOnItem.koumoku9, 2);
    }

    // S1
    let stringItem10 = '-';
    if (this.props.dataDayOnItem.koumoku10 !== '') {
      stringItem10 = commonLogic.numberFormat(this.props.dataDayOnItem.koumoku10, 2);
    }

    // ベース
    let stringItem11 = '-';
    if (this.props.dataDayOnItem.koumoku11 !== '') {
      stringItem11 = commonLogic.numberFormat(this.props.dataDayOnItem.koumoku11, 2);
    }

    // BY
    let stringItem12 = '-';
    if (this.props.dataDayOnItem.koumoku12 !== '') {
      stringItem12 = commonLogic.numberFormat(this.props.dataDayOnItem.koumoku12, 2);
    }

    // BYmin
    let stringItem13 = '-';
    if (this.props.dataDayOnItem.koumoku13 !== '') {
      stringItem13 = commonLogic.numberFormat(this.props.dataDayOnItem.koumoku13, 2);
    }

    // T1Y
    let stringItem14 = '-';
    if (this.props.dataDayOnItem.koumoku14 !== '') {
      stringItem14 = commonLogic.numberFormat(this.props.dataDayOnItem.koumoku14, 0);
    }

    // TY
    let stringItem15 = '-';
    if (this.props.dataDayOnItem.koumoku15 !== '') {
      stringItem15 = commonLogic.numberFormat(this.props.dataDayOnItem.koumoku15, 0);
    }

    // 250玉スタート
    let stringItem16 = '-';
    if (this.props.dataDayOnItem.koumoku16 !== '') {
      stringItem16 = commonLogic.numberFormat(this.props.dataDayOnItem.koumoku16, 2);
    }

    // 初当確率
    let stringItem17 = '-';
    if (this.props.dataDayOnItem.koumoku17 !== '') {
      stringItem17 = commonLogic.numberFormat(this.props.dataDayOnItem.koumoku17, 2);
    }

    // SA
    let stringItem18 = '-';
    if (this.props.dataDayOnItem.koumoku18 !== '') {
      stringItem18 = commonLogic.numberFormat(this.props.dataDayOnItem.koumoku18, 2);
    }

    // BA
    let stringItem19 = '-';
    if (this.props.dataDayOnItem.koumoku19 !== '') {
      stringItem19 = commonLogic.numberFormat(this.props.dataDayOnItem.koumoku19, 2);
    }

    // TO
    let stringItem20 = '-';
    if (this.props.dataDayOnItem.koumoku20 !== '') {
      stringItem20 = commonLogic.numberFormat(this.props.dataDayOnItem.koumoku20, 0);
    }

    // T1O
    let stringItem21 = '-';
    if (this.props.dataDayOnItem.koumoku21 !== '') {
      stringItem21 = commonLogic.numberFormat(this.props.dataDayOnItem.koumoku21, 0);
    }

    // 客滞率
    let stringItem22 = '-';
    if (this.props.dataDayOnItem.koumoku22 !== '') {
      stringItem22 = commonLogic.numberFormat(this.props.dataDayOnItem.koumoku22, 2);
    }

    // メーカー
    let stringItem23 = '-';
    if (this.props.dataDayOnItem.koumoku23 !== '') {
      stringItem23 = this.props.dataDayOnItem.koumoku23;
    }

    // タイプ
    let stringItem24 = '-';
    if (this.props.dataDayOnItem.koumoku24 !== '') {
      stringItem24 = this.props.dataDayOnItem.koumoku24;
    }

    // 設置台数
    let stringItem25 = '-';
    if (this.props.dataDayOnItem.koumoku25 !== '') {
      stringItem25 = commonLogic.numberFormat(this.props.dataDayOnItem.koumoku25, 0);
    }

    let stringRow = this.props.dataDayOnItem.cnt;
    let stringClass;

    if (stringRow == 1) {
      stringClass = 'row1 highlight';
    } else {
      stringClass = 'row' + stringRow;
    }

    let rowName = stringClass;

    return (
      <div className="border_b">
        <div className={rowName}>
          <div className="col2 sheet_data ib vm border_r col_koumoku">
            <p>{nohinkaishibi}</p>
          </div>
          <div className="col3 sheet_data ib vm border_r col_koumoku">
            {stringItem1.match('-') && stringItem1 != '-' ? (<p style={NumberStyle}>{stringItem1}</p>) : (<p>{stringItem1}</p>)}
          </div>
          <div className="col4 sheet_data ib vm border_r col_koumoku">
            {stringItem2.match('-') && stringItem2 != '-' ? (<p style={NumberStyle}>{stringItem2}</p>) : (<p>{stringItem2}</p>)}
          </div>
          <div className="col5 sheet_data ib vm border_r col_koumoku">
            {stringItem3.match('-') && stringItem3 != '-' ? (<p style={NumberStyle}>{stringItem3}</p>) : (<p>{stringItem3}</p>)}
          </div>
          <div className="col6 sheet_data ib vm border_r col_koumoku">
            {stringItem4.match('-') && stringItem4 != '-' ? (<p style={NumberStyle}>{stringItem4}</p>) : (<p>{stringItem4}</p>)}
          </div>
          <div className="col7 sheet_data ib vm border_r col_koumoku">
            {stringItem5.match('-') && stringItem5 != '-' ? (<p style={NumberStyle}>{stringItem5}</p>) : (<p>{stringItem5}</p>)}
          </div>
          <div className="col8 sheet_data ib vm border_r col_koumoku">
            {stringItem6 != '-' ? (
              <a className={`used_machine_price ${stringItem6Style}`} href="#" onClick={(event) => { commonLogic.handleUsedMachinePriceClick(event, kisyuCd); }}>&yen;{stringItem6}</a>
            ) : (
              <a className="used_machine_price" href="#" onClick={(event) => { commonLogic.handleUsedMachinePriceClick(event, kisyuCd); }}>{stringItem6}</a>
            )}
          </div>
          <div className="col9 sheet_data ib vm border_r col_koumoku">
            {formatItemYen(stringItem7)}
          </div>
          <div className="col10 sheet_data ib vm border_r col_koumoku">
            {stringItem8.match('-') && stringItem8 != '-' ? (<p style={NumberStyle}>{stringItem8}</p>) : (<p>{stringItem8}</p>)}
          </div>
          <div className="col11 sheet_data ib vm border_r col_koumoku">
            {stringItem9.match('-') && stringItem9 != '-' ? (<p style={NumberStyle}>{stringItem9}</p>) : (<p>{stringItem9}</p>)}
          </div>
          <div className="col12 sheet_data ib vm border_r col_koumoku">
            {stringItem10.match('-') && stringItem10 != '-' ? (<p style={NumberStyle}>{stringItem10}</p>) : (<p>{stringItem10}</p>)}
          </div>
          <div className="col13 sheet_data ib vm border_r col_koumoku">
            {stringItem11.match('-') && stringItem11 != '-' ? (<p style={NumberStyle}>{stringItem11}</p>) : (<p>{stringItem11}</p>)}
          </div>

          <div className="col14 sheet_data ib vm border_r col_koumoku">
            {stringItem12.match('-') && stringItem12 != '-' ? (<p style={NumberStyle}>{stringItem12}</p>) : (<p>{stringItem12}</p>)}
          </div>

          <div className="col15 sheet_data ib vm border_r col_koumoku">
            {stringItem13.match('-') && stringItem13 != '-' ? (<p style={NumberStyle}>{stringItem13}</p>) : (<p>{stringItem13}</p>)}
          </div>

          <div className="col16 sheet_data ib vm border_r col_koumoku">
            {stringItem14.match('-') && stringItem14 != '-' ? (<p style={NumberStyle}>{stringItem14}</p>) : (<p>{stringItem14}</p>)}
          </div>

          <div className="col17 sheet_data ib vm border_r col_koumoku">
            {stringItem15.match('-') && stringItem15 != '-' ? (<p style={NumberStyle}>{stringItem15}</p>) : (<p>{stringItem15}</p>)}
          </div>

          <div className="col18 sheet_data ib vm border_r col_koumoku">
            {stringItem16.match('-') && stringItem16 != '-' ? (<p style={NumberStyle}>{stringItem16}</p>) : (<p>{stringItem16}</p>)}
          </div>

          <div className="col19 sheet_data ib vm border_r col_koumoku">
            {stringItem17.match('-') && stringItem17 != '-' ? (<p style={NumberStyle}>{stringItem17}</p>) : (<p>{stringItem17}</p>)}
          </div>

          <div className="col20 sheet_data ib vm border_r col_koumoku">
            {stringItem18.match('-') && stringItem18 != '-' ? (<p style={NumberStyle}>{stringItem18}</p>) : (<p>{stringItem18}</p>)}
          </div>

          <div className="col21 sheet_data ib vm border_r col_koumoku">
            {stringItem19.match('-') && stringItem19 != '-' ? (<p style={NumberStyle}>{stringItem19}</p>) : (<p>{stringItem19}</p>)}
          </div>

          <div className="col22 sheet_data ib vm border_r col_koumoku">
            {stringItem20.match('-') && stringItem20 != '-' ? (<p style={NumberStyle}>{stringItem20}</p>) : (<p>{stringItem20}</p>)}
          </div>

          <div className="col23 sheet_data ib vm border_r col_koumoku">
            {stringItem21.match('-') && stringItem21 != '-' ? (<p style={NumberStyle}>{stringItem21}</p>) : (<p>{stringItem21}</p>)}
          </div>

          <div className="col24 sheet_data ib vm border_r col_koumoku">
            {stringItem22.match('-') && stringItem22 != '-' ? (<p style={NumberStyle}>{stringItem22}</p>) : (<p>{stringItem22}</p>)}
          </div>

          <div className="col25 sheet_data ib vm border_r col_koumoku">
            <p className="grid_string" title={stringItem23}>{stringItem23}</p>
          </div>

          <div className="col26 sheet_data ib vm border_r col_koumoku">
            <p className="grid_string" title={stringItem24}>{stringItem24}</p>
          </div>

          <div className="col27 sheet_data ib vm border_r col_koumoku">
            {stringItem25.match('-') && stringItem25 != '-' ? (<p style={NumberStyle}>{stringItem25}</p>) : (<p>{stringItem25}</p>)}
          </div>
        </div>
      </div>
    );
  }
}

MainGridMiddleRightRowDayOnTypePachi.propTypes = {
  dataDayOnItem: PropTypes.any.isRequired,
  actions: PropTypes.any.isRequired,
};

export default MainGridMiddleRightRowDayOnTypePachi;
